import { Button } from '@design-system/button';
import { FluidGrid } from '@design-system/fluid-grid';
import { ProductCard } from '@design-system/product-card';
import { setLocalStorageData } from '@phx-husky/local-storage';
import React, { FC, useMemo } from 'react';

import TMPLinkWrap from '~/components/TMPLinkWrap';
import { gatsbyImageMapper } from '~/mappers/image';
import { gtmService } from '~/services/gtm';
import { GTM_LOCALSTORAGE_DATA } from '~/utils/constants';

import { ProductListingProps } from '../models';

export const ProductListing: FC<ProductListingProps> = ({
  items = [],
  maxVisibleItems,
  moreButtonText,
  setTabValue,
  tabNumber,
  imageSettings,
  fluidGrid,
}) => {
  const visibleItems = useMemo(() => {
    if (maxVisibleItems) {
      return items.slice(0, maxVisibleItems);
    }

    return items;
  }, [maxVisibleItems, items]);

  if (!items.length) {
    return null;
  }

  const onCLickProductCard = (index) => {
    setLocalStorageData(GTM_LOCALSTORAGE_DATA.lastProductIndex, index + 1);
    gtmService.emitSelectItem(visibleItems[index], { index: index + 1 });
  };

  return (
    <>
      <FluidGrid {...fluidGrid}>
        {visibleItems.map(({ sku, title, description, image, url }, index) => (
          <div className="search-result__product-listing" key={sku}>
            <ProductCard
              cardContent={{
                headingBlock: {
                  headline: title,
                  description,
                  headlineVariant: 'headline',
                  headlineSize: 'm',
                },
              }}
              {...(image && {
                cardMedia: {
                  image: {
                    element:
                      gatsbyImageMapper({
                        ...{
                          alt: image.title,
                          image: {
                            gatsbyImageData: image.data.gatsbyImageData,
                            url: image.url,
                          },
                        },
                        ...imageSettings,
                      }) || undefined,
                  },
                },
              })}
              link={{
                component: TMPLinkWrap,
                props: {
                  href: url,
                  onClick: () => onCLickProductCard(index),
                },
              }}
            />
          </div>
        ))}
      </FluidGrid>
      <div className="search-result__button-wrapper">
        <Button variant="secondary" onClick={() => setTabValue(tabNumber)}>
          {moreButtonText}
        </Button>
      </div>
    </>
  );
};

export default ProductListing;
